import { Link } from "react-router-dom";

export default function SiteHeader() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full bg-white/90 backdrop-blur-md border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="header-logo">
          <div className="h-8 w-8 rounded-md bg-navy flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0 bg-electric opacity-0 group-hover:opacity-100 transition-opacity" />
            <svg viewBox="0 0 24 24" className="h-4 w-4 text-white relative" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M3 3v18h18" />
              <path d="M7 14l4-4 3 3 5-6" />
            </svg>
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-display text-[15px] font-extrabold text-navy tracking-tight">CompetitorPulse</span>
            <span className="text-[10px] font-mono tracking-widest text-slate-500 uppercase">Fintech CI</span>
          </div>
        </Link>
        <a
          href="https://emergent.sh"
          target="_blank"
          rel="noreferrer"
          className="hidden sm:inline-flex items-center gap-2 text-xs font-medium text-slate-500 hover:text-navy transition-colors"
          data-testid="header-emergent-link"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-electric pulse-dot" />
          Powered by Claude Sonnet 5
        </a>
      </div>
    </header>
  );
}
